import { observer } from 'mobx-react';
import React from 'react';
import { Link } from '../../../lib/components';
import { TreeNode } from './models/tree-node';
import { useTranslation } from 'react-i18next';

function TreeNodeView(props: { node: TreeNode }) {
  const node = props.node;

  const hasChildren = node.children.length > 0;
  const expanded = node.expanded;
  const iconClassname = expanded ?
    'fas fa-minus' :
    'fas fa-plus';

  const selected = node.selected;
  const data = node.data;
  const containerClassName = selected
    ? 'node-container node-selected'
    : 'node-container';

  const collapsibleWrapperClass = (hasChildren && !node.expanded)
    ? 'collapsible-wrapper collapsed'
    : 'collapsible-wrapper';

    const {t} = useTranslation();

  function onExpandIconClick(event: any) {
    props.node.toggleExpand();
  };

  return (
    <div className="node">
      <div className={containerClassName}>
        <Link className="node-name" to={data.route}>
          {data.icon && <i className={data.icon}></i>}
          {t( data.label)}
        </Link>

        <div className="node-icon"
          onClick={onExpandIconClick}>
          {
            (hasChildren) &&
            <i className={iconClassname} />
          }
        </div>

      </div>

      {
        hasChildren &&
        <div className={collapsibleWrapperClass}>
          <div className="collapsible">
            {node.children.map(child =>
            (<TreeNodeComponent key={child.data.route}
              node={child} />))}
          </div>
        </div>
      }
    </div>
  );
}

export const TreeNodeComponent = observer(TreeNodeView);
